const {$} = window;
$.fn.showComponentLoader = function(useAbsolutePosition) {
    let $loader = this.find('.js-component-loader');
    // make sure the component has an id. The id is
    // needed to properly show/hide the loader
    if (!this.attr('id')) { 
        this.attr('id', `component_loader_${Date.now()}`);
    }

    const id = this.attr('id');


    // create loader for this component if it hasn't been created already. Otherwise just show it'
    if (!$loader.length) {
        $loader = createComponentLoader(this, useAbsolutePosition);
    }

    // don't show loader if this resolves in less than 200ms
    // create a unique reference to this loader, so we are able to clear it via $.fn.hideComponentLoader
    window[`${id}_componentLoaderAnimationTimer`] = window.setTimeout(function () {
        $loader.fadeIn(100);
        window.requestAnimationFrame(function() { $loader.addClass('animate'); });
    }, 200);
};

$.fn.hideComponentLoader = function() {
    const $loader = this.find('.js-component-loader');
    const animationTimer = window[`${this.attr('id')}_componentLoaderAnimationTimer`];
    if (!$loader.length) return;
    window.clearTimeout(animationTimer);

    $loader.removeClass('animate');
    $loader.fadeOut(100);
};

function createComponentLoader($elem, useAbsolutePosition) {
    const loader = document.createElement('div');
    const background = document.createElement('div');
    const spinner = document.createElement('img');

    loader.classList.add('component-loader');
    loader.classList.add('js-component-loader');
    if (useAbsolutePosition) {
        loader.style.position = 'absolute';
        loader.style.top = '0';
        loader.style.bottom = '0';
        loader.style.left = '0';
        loader.style.right = '0';
        loader.style.zIndex = '99999';
    }
    background.classList.add('component-loader_background');
    spinner.src = 'images/16_simple-spinner.svg';
    spinner.classList.add('component-loader_spinner');

    loader.appendChild(background);
    loader.appendChild(spinner);

    $elem.append(loader);

    return $(loader);
}